// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__H-VEc","name":"ConsentHeader_name__2QJnz","birthday":"ConsentHeader_birthday__zR9Gi","skeleton":"ConsentHeader_skeleton__16PaC"};